import { BillingGLAccountLabelSelectorResultDto } from '../../../../../billing-rules-module/_models/billing-late-fee-models/billing-gl-account-label-selector-result-dto';

export class GLAccountLabelSelectorResultDto extends BillingGLAccountLabelSelectorResultDto {
    code: string;
    title: string;
    glAccountNumber: string;
    offsetGLAccountNumber: string;
    glAccountTitle: string;
    offsetGLAccountTitle: string;
    subCategoryCode: string;

    // transient variable
    displayText: string;
    labelDisplayText: string;
}
